export default "/images/e8a6e9f959fc3ec17fda462bc518a42f.png";